import { Box } from '@/components/Layout'
import { Text } from '@/components/Data'
import { BookSeatsLogo } from '@/assets/icons'
import { useTranslations } from '@/core/translation'
import { bannerPoweredByStyles as styles } from './BannerPoweredBy.style'
import { BannerPoweredByProps } from './BannerPoweredBy.types'

export default function BannerPoweredBy({ inline = false }: BannerPoweredByProps) {
  const t = useTranslations('banner')

  return (
    <Box sx={inline ? styles.poweredByInline : styles.poweredBy}>
      <Text sx={styles.poweredByLabel}>{t('poweredBy')}:</Text>
      <Box component={BookSeatsLogo} sx={styles.poweredByLogo} />
    </Box>
  )
}
